import { useRef, useState } from "react";
import { Overlay, Popover, Button, Form, Badge } from "react-bootstrap";

export function CompactMultiSelect({
  id,
  options,
  value = [],
  onChange,
  disabled,
  maxLabelChars = 8,
}) {
  const btnRef = useRef(null);
  const [show, setShow] = useState(false);

  const toggle = () => setShow((s) => !s);
  const close = () => setShow(false);

  const selectedCount = value.length;
  const firstLabel = (() => {
    const first = options.find((o) => o.value === value[0]);
    if (!first) return "";
    const trimmed =
      first.label.length > maxLabelChars
        ? first.label.slice(0, maxLabelChars) + "…"
        : first.label;
    return trimmed;
  })();

  const summary =
    selectedCount === 0
      ? "Select"
      : selectedCount === 1
      ? firstLabel
      : `${firstLabel} +${selectedCount - 1}`;

  const handleToggleOne = (val) => {
    const exists = value.includes(val);
    const next = exists ? value.filter((v) => v !== val) : [...value, val];
    onChange(next);
  };

  return (
    <>
      <Button
        ref={btnRef}
        variant="outline-secondary"
        size="sm"
        onClick={toggle}
        disabled={disabled}
        className="w-100 text-truncate d-flex align-items-center justify-content-start rounded-0"
        title={value
          .map((v) => options.find((o) => o.value === v)?.title || v)
          .join(", ")}
        style={{
          minHeight: "30px",
          padding: "0.25rem 0.5rem",
          textAlign: "left",
        }}
      >
        <Badge bg={selectedCount ? "primary" : "secondary"} className="me-2">
          {selectedCount}
        </Badge>
        <span className="text-truncate">{summary}</span>
      </Button>

      <Overlay target={btnRef.current} show={show} placement="bottom">
        <Popover
          id={id}
          className="popover-square rounded-0"
          style={{ minWidth: 260, maxWidth: 360 }}
        >
          <Popover.Header
            as="h6"
            className="d-flex justify-content-between align-items-center rounded-0 text-primary"
            style={{ backgroundColor: "#CFE2FF" }}
          >
            Select secondary ICD-10
            <Button
              variant="link"
              size="sm"
              onClick={() => {
                onChange([]);
              }}
            >
              <i className="fa-solid fa-trash-can text-danger"></i>
            </Button>
          </Popover.Header>

          <Popover.Body className="rounded-0" style={{ maxHeight: 220, overflowY: "auto" }}>
            {options.length === 0 ? (
              <div className="text-muted small">No secondary ICD-10 available</div>
            ) : (
              <div className="d-flex flex-column gap-1">
                {options.map((opt) => (
                  <Form.Check
                    key={opt.value}
                    type="checkbox"
                    id={`${id}-${opt.value}`}
                    label={opt.label}
                    title={opt.title || opt.label}
                    checked={value.includes(opt.value)}
                    onChange={() => handleToggleOne(opt.value)}
                  />
                ))}
              </div>
            )}
          </Popover.Body>

          <div className="d-flex justify-content-end p-2 pt-0">
            <Button size="sm" variant="primary" onClick={close} className="rounded-0">
              Done
            </Button>
          </div>
        </Popover>
      </Overlay>
    </>
  );
}
